import React from 'react';
// import InnerBanner from './InnerBanner';
import ClientsImage from '../Clients/ClientsImage';
import {  Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import ContactForm from '../ContactForm/ContactForm'; 
import Footer from '../Footer/Footer';
import contact from '../assets/images/contact-banner.jpg';

const Contact = () => {
  return (
    <>
      
      <div className="bannermn">
        <img src={contact} alt="Banner" />
    </div>    
      <div>


        <section>
        <Container>
          <Row>
            <Col lg={12}>
              <h2>Contact us</h2>
              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form by slightly. </p>
            </Col>

            <Col lg={6}>
            <ContactForm />  
            </Col>
          </Row>
        </Container>
        
        </section>
      </div>

      {/* clients logo section  */}
      <section id="section4" className="section">
        <ClientsImage />
      </section>


       {/* Footer  */}
      <section className='p-0'>
        <Footer />
      </section>
    </>

  );
};

export default Contact;